<template>
  <div class="">
    <div class="mt-3">
      <div class="px-0 px-md-5 py-3 pt-md-5 pb-md-2">
        <h4 class="display-4 ml-5 pl-0 ml-md-0 pl-sm-4 text-left  text-md-center text-cabecera"
            :style="{'font-weight': 500,'font-size':estilo.cabecera['font-size']+'px',color:estilo.cabecera.color}">
          Resuelve tus dudas
        </h4>
        <div class="col-12 col-md-10 col-lg-6 mx-auto">
          <buscador class="justify-content-center align-content-center"
                    style="border-radius: 40px;"></buscador>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import buscador from '../share/buscador';

  export default {
    name: "cabecera",
    data() {
      return {
        estilo: {cabecera: {'font-size': '0', color: '#000'}}
      }
    },
    components: {
      buscador
    },
    created() {
      EventBus.$on('paginaInicio', this.estilos);
    },
    methods: {
      estilos: function (data) {
        // console.log(63,'this.estilo.cabecera = data.cabecera;', data);
        this.estilo.cabecera = data.cabecera;

      }
    }
  }
</script>

<style scoped lang="scss">
  .imagen-empresa {
    height: 100px;
  }

  .text-cabecera {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/publico/fragmentosInicio/cabecera.vue